export const DEFAULT_BREAKPOINT = 768;

export function isMobileBreakpoint(breakpoint = DEFAULT_BREAKPOINT): boolean {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false;
  }
  return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
}

type Unsubscribe = () => void;

export function subscribeToMobileBreakpointChange(
  callback: (isMobile: boolean) => void,
  breakpoint = DEFAULT_BREAKPOINT,
): Unsubscribe {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return () => {};
  }

  const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
  const handler = (ev: MediaQueryListEvent | MediaQueryList) => {
    const matches = 'matches' in ev ? ev.matches : mq.matches;
    callback(matches);
  };

  // Modern addEventListener only
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', handler as EventListener);
  }

  return () => {
    if (typeof mq.removeEventListener === 'function') {
      mq.removeEventListener('change', handler as EventListener);
    }
  };
}
